module.exports = __webpack_public_path__ + "static/media/3Beam-01.d85d41f4.png";